export const useQueryParameters = () => {
  const getQueryParam = (key: string): string | null => {
    const params = new URLSearchParams(window.location.search)
    return params.get(key)
  }

  const getInternalToken = (): string => {
    return getQueryParam('internalToken') ?? ''
  }

  const copyCurrentFullUrlToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href)
      console.info('[Query] Full current URL copied to clipboard.')
    } catch (err) {
      console.error('[Query] Failed to copy current URL:', err)
    }
  }

  const hasCopiedUrl = ref(false)

  const onCopyUrl = async () => {
    await copyCurrentFullUrlToClipboard()
    hasCopiedUrl.value = true

    setTimeout(() => {
      hasCopiedUrl.value = false
    }, 2000)
  }

  return {
    onCopyUrl,
    hasCopiedUrl,
    getInternalToken,
  }
}
